<template>
  <div class="index">
    <div class="banner">
      <img src="@/assets/images/indexbanner.jpg" alt="">
    </div>
    <div class="bgc">
      <div class="bx-content">
        <div class="box-item">
          <div class="item-title">
            <b>海淀区已取得科技类《非学科类校外培训机构培训许可证》机构名单及星级评定情况</b>
          </div>
          <div class="item-list">
<!--        <p class="ovHide" v-for="item in chi" :key="item.id" @click="showMask(item)">{{item.org_name}}</p>-->
            <div class="item-child" v-for="item in yi" :key="item.id" @click="showMask(item)">
              <div class="child-tex ovHide2">{{item.org_name}}</div>
              <div class="child-start">
                <i class="iconfont icon-f-star" v-if="item.star > 0"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 1"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 2"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 3"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 4"></i>
              </div>
            </div>
            <span @click="to('/masses/yiList','',1)" class="more">查看更多 +</span>
          </div>
        </div>

        <div class="box-item zijin">
          <div class="item-title ">
            <b>海淀区未取得科技类《非学科类校外培训机构培训许可证》机构名单及星级评定情况</b>
          </div>
          <div class="item-list">
<!--            <p class="ovHide" v-for="item in kai" :key="item.id" @click="showMask(item)">{{item.org_name}}</p>-->

            <div class="item-child" v-for="item in wei" :key="item.id" @click="showMask(item)">
              <div class="child-tex ovHide2">{{item.org_name}}</div>
              <div class="child-start">
                <i class="iconfont icon-f-star" v-if="item.star > 0"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 1"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 2"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 3"></i>
                <i class="iconfont icon-f-star" v-if="item.star > 4"></i>
              </div>
            </div>
            <span @click="to('/masses/weiList','',2)">查看更多 +</span>
          </div>
        </div>

        <div class="item-flex align-start">
          <div class="haha">
            <div class="itm-box fengxian">
              <b>风险预警机构名单</b>
              <span @click="to('/masses/yuList','',2)">查看更多 +</span>
            </div>
            <div class="item-list">
<!--              <div class="yj-itm">-->
<!--                <div class="xh">序号</div>-->
<!--                <div class="nme">机构名称</div>-->
<!--                <div class="sta">预警状态</div>-->
<!--              </div>-->
              <div class="yj-itm height" v-for="item in yu" :key="item.id" @click="showMask(item)">
<!--                <div class="xh">{{index + 1}}</div>-->
                <div class="nme ovHide">{{item.org_name}}</div>
                <div class="sta">{{item.warning}}</div>
              </div>
            </div>
          </div>
          <div class="haha">
            <div class="itm-box">
              <b>开通资金监管账户机构名单</b>
              <span @click="to('/masses/orgList','',2)">查看更多 +</span>
            </div>
            <div class="item-list">
              <p class="ovHide" v-for="item in kai" :key="item.id" @click="showMask(item)">{{item.org_name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bx-content">
      <div class="title-box">
        <div class="title-tex">
          <b>宣传信息</b>
          <p>SPREAD INFORMATION</p>
        </div>
        <div class="more" @click="to('/masses/publicizeList','',3)">查看更多 +</div>
      </div>
      <div class="flex-list margin-top">
        <div class="flex-left" v-if="one">
          <div class="left-img">
            <img :src="one.thumb" alt="">
          </div>
          <div class="left-time">
            <i class="iconfont icon-date"></i>{{one.publish_time}}
          </div>
          <div class="left-title ovHide2">{{one.title}}</div>
          <div class="left-more" @click="to('/masses/detail',one.id,3)">
            查看详情 <i class="iconfont icon-jiantouyou"></i>
          </div>
        </div>
        <div class="flex-right">
          <div class="item" v-for="item in right" :key="item.id" @click="to('/masses/detail',item.id,3)">
            <div class="item-img">
              <img :src="item.thumb" alt="">
            </div>
            <div class="item-cont">
              <div class="item-time">
                <i class="iconfont icon-date"></i>{{item.publish_time}}
              </div>
              <div class="item-title ovHide2">{{item.title}}</div>
              <div class="item-more" >
                查看详情 <i class="iconfont icon-jiantouyou"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bgc">
      <div class="bx-content">
        <div class="item-flex p0 ">
          <div class="item-box width zhengce" @click="to('/masses/policyList','',1)">
            <b>政策法规</b>
            <span>查看更多 +</span>
          </div>
          <div class="item-box width keji" @click="to('/masses/technologyList','',5)">
            <b>科技专栏</b>
            <span>查看更多 +</span>
          </div>
        </div>
      </div>
    </div>
    <orgDetailDialog :dialogVisible="dialogVisible" :item="item" @handleClose="handleClose" />
  </div>
</template>
<script>
import {masses_index, masses_star_lst} from "@/api";
import orgDetailDialog from "@/views/masses/common/orgDetailDialog";
export default {
  name: "index",
  data() {
    return {
      dialogVisible:false,
      item:{},
      chi:[],
      kai:[],
      one:[],
      right:[],
      yi:[],
      wei:[],
      yu:[],
    }
  },
  components: {orgDetailDialog},
  created() {
    this.init()
    this.list(1,1,5)
    this.list(2,1,5)
    this.list(3,1,1)
  },
  methods: {
    async init(){
      let _data = await masses_index();
      if(_data.status == 200){
        this.chi = _data.data.chi;
        this.kai = _data.data.kai;
        this.one = _data.data.one;
        this.right = _data.data.right;
      }

    },

    async list(license,page,limit){
      let _data = await masses_star_lst(license,page,limit);
      if(_data.status == 200){
        console.log(_data.data)
        if(license == 1) {
          this.yi = _data.data.data
        }
        if(license == 2) {
          this.wei = _data.data.data
        }
        if(license == 3) {
          this.yu = _data.data
        }

      }
    },

    to(path,id,type){
      this.$router.push({
        path: path,
        query: {
          id: id,
          type: type
        }
      })
    },

    showMask(item) {
      this.item = item;
      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false
      this.item = {}
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.index {
  .flex-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 75px;
    .flex-right {
      width: 738px;
      //height: 705px;
      //overflow-y: hidden;
      .item {
        width: 100%;
        background-image: linear-gradient(0deg,
          #ffffff 84%,
          #eff7ff 100%);
        box-shadow: 11px 8px 18px 0px
        rgba(0, 46, 108, 0.17);
        border-radius: 8px;
        border: solid 1px #ffffff;
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 25px;
        &:nth-child(3n) {
          margin-bottom: 0;
        }
        .item-cont {
          flex: 1;
          width: 0;
          height: 176px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          padding: 2px 0;
          .item-more {
            width: 110px;
            height: 38px;
            background-image: linear-gradient(0deg,
              #2791ff 0%,
              #81b6ff 100%);
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #ffffff;
            cursor: pointer;
            i {
              font-size: 14px;
              color: #ffffff;
              margin-left: 10px;
            }
          }
          .item-title {
            width: 100%;
            font-size: 18px;
            color: #141c24;
            margin-top: 20px;
            margin-bottom: 40px;
          }
          .item-time {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            color: #999999;
            i {
              font-size: 18px;
              color: #999999;
              margin-right: 10px;
            }
          }
        }
        .item-img {
          width: 220px;
          height: 176px;
          background-color: #f8faff;
          border-radius: 8px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
        }
      }
    }
    .flex-left {
      width: 736px;
      height: 705px;
      background-image: linear-gradient(0deg,
        #ffffff 84%,
        #eff7ff 100%);
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 25px 30px;
      .left-title {
        width: 100%;
        font-size: 18px;
        color: #0d7bff;
      }
      .left-more {
        width: 110px;
        height: 38px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #4698fb;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4698fb;
        font-size: 14px;
        margin-top: 45px;
        cursor: pointer;
        i {
          font-size: 18px;
          color: #4698fb;
          margin-left: 10px;
        }
      }
      .left-time {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        color: #999999;
        padding: 15px 0;
        i {
          font-size: 20px;
          color: #999999;
          margin-right: 10px;
        }
      }
      .left-img {
        width: 100%;
        height: 446px;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }
    }
    .flex-right {}
  }
  .title-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 65px;
    .more {
      font-size: 18px;
      color: #4698fb;
      cursor: pointer;
    }
    .title-tex {
      p {
        display: block;
        font-size: 16px;
        color: #999999;
        letter-spacing: 1px;
      }
      b {
        display: block;
        font-size: 40px;
        color: #4698fb;
        font-weight: bold;
        line-height: 48px;
      }
    }
  }
  .bgc {
    width: 100%;
    padding: 100px 0;
    background: #ebf4ff;
    .item-flex {
      width: 100%;
      padding-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.align-start {
        align-items: flex-start;
      }
      &.p0 {
        padding-top: 0;
      }

      .haha {
        width: 738px;
        .itm-box {
          width: 100%;
          height: 138px;
          background: url("../../../assets/images/xingjititle.png") no-repeat;
          background-size: 100% 100%;
          padding-left: 20px;
          padding-right: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &.fengxian {
            background: url("../../../assets/images/fengxiantitle.png") no-repeat;
            background-size: 100% 100%;
            padding-right: 60px;
            .item-list {
              background-image: linear-gradient(0deg,
                #ffefef 0%,
                #ffffff 100%);
              box-shadow: 11px 8px 18px 0px
              rgba(0, 46, 108, 0.17);
            }
          }
          b {
            font-size: 30px;
            letter-spacing: 1px;
            color: #ffffff;
            font-weight: bold;
          }
          span {
            font-size: 18px;
            color: #ffffff;
            height: 39px;
            border-bottom: 1px solid #ffffff;
            line-height: 39px;
            cursor: pointer;
          }
        }
        .item-list {
          background-image: linear-gradient(0deg,
            #ebe9ff 24%,
            #ffffff 100%);
          box-shadow: 11px 8px 18px 0px
          rgba(0, 46, 108, 0.17);
          padding: 15px 15px 5px 15px;
          border-radius: 0 0 8px 8px;

          .yj-itm {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            .sta {
              width: 152px;
              height: 70px;
              background-color: #ffffff;
              box-shadow: 0px 0px 16px 0px
              rgba(7, 65, 149, 0.05);
              border-radius: 10px;
              font-size: 20px;
              color: #64676d;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .nme {
              flex: 1;
              width: 0;
              height: 70px;
              background-color: #ffffff;
              box-shadow: 0px 0px 16px 0px
              rgba(7, 65, 149, 0.05);
              border-radius: 10px;
              margin-right: 15px;
              font-size: 20px;
              color: #64676d;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0 10px;
            }
            .xh {
              width: 96px;
              height: 70px;
              background-color: #ffffff;
              box-shadow: 0px 0px 16px 0px
              rgba(7, 65, 149, 0.05);
              border-radius: 10px;
              font-size: 20px;
              color: #64676d;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            &.height {
              .xh {
                height: 70px;
              }
              .nme {
                height: 70px;
              }
              .sta {
                height: 70px;
              }
            }
          }

          p {
            width: 100%;
            height: 70px;
            background-color: #ffffff;
            box-shadow: 0px 0px 16px 0px
            rgba(7, 65, 149, 0.05);
            border-radius: 10px;
            padding: 0 20px;
            margin-bottom: 15px;
            font-size: 19px;
            color: #64676d;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .item-box {
        width: 100%;
        height: 138px;
        background: url("../../../assets/images/xingjititle.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 47px;
        padding-right: 144px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.width {
          width: 738px;
        }
        &.zhengce {
          background: url("../../../assets/images/zhengfatitle.png") no-repeat;
          background-size: 100% 100%;
          padding-right: 154px;
        }
        &.keji {
          background: url("../../../assets/images/kejititle.png") no-repeat;
          background-size: 100% 100%;
          padding-right: 164px;
        }
        &.fengxian {
          background: url("../../../assets/images/fengxiantitle.png") no-repeat;
          background-size: 100% 100%;
          padding-right: 170px;
        }
        b {
          font-size: 34px;
          letter-spacing: 1px;
          color: #ffffff;
          font-weight: bold;
        }
        span {
          font-size: 18px;
          color: #ffffff;
          height: 39px;
          border-bottom: 1px solid #ffffff;
          line-height: 39px;
          cursor: pointer;
        }
      }
    }
    .box-item {
      width: 100%;
      min-height: 352px;
      background-image: linear-gradient(0deg,
        #e7fcff 0%,
        #ffffff 100%);
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      .item-list {
        width: 100%;
        min-height: 215px;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        span {
          width: 460px;
          height: 70px;
          background-color: #ffffff;
          box-shadow: 0px 0px 16px 0px
          rgba(7, 65, 149, 0.05);
          border-radius: 10px;
          padding: 0 25px;
          margin: 10px;
          line-height: 70px;
          font-size: 22px;
          color: #7ad5dd;
          text-align: center;
          cursor: pointer;
        }

        .item-child {
          width: 460px;
          height: 70px;
          background-color: #ffffff;
          box-shadow: 0px 0px 16px 0px
          rgba(7, 65, 149, 0.05);
          border-radius: 10px;
          padding: 0 20px;
          margin: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .child-tex {
            flex: 1;
            width: 0;
            margin-right: 12px;
            font-size: 19px;
            color: #64676d;
            cursor: pointer;
          }
          .child-start {
            width: max-content;
            display: flex;
            justify-content: flex-end;
            i {
              font-size: 22px;
              color: #fcd822;
              margin: 0 3px;
            }
          }
        }

      }
      .item-title {
        width: 100%;
        height: 138px;
        background: url("../../../assets/images/jigoutitle.png") no-repeat;
        background-size: 100% 100%;
        line-height: 138px;
        padding-left: 45px;

        b {
          font-size: 30px;
          letter-spacing: 1px;
          color: #ffffff;
          font-weight: bold;
        }
      }
      &.zijin {
        background-image: linear-gradient(0deg,
          #e1eeff 0%,
          #ffffff 100%);
        box-shadow: 11px 8px 18px 0px
        rgba(0, 46, 108, 0.17);
        margin-top: 50px;
        .item-title {
          background: url("../../../assets/images/zijintitle.png") no-repeat;
          background-size: 100% 100%;
        }
        .item-list {
          span {
            color: #67aeff;
          }
        }
      }
    }
  }

  .banner {
    width: 100%;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>


